var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAddGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 35.999C28.8364 35.999 36 28.8364 36 19.999C36 11.1626 28.8364 4 20 4C11.1636 4 4 11.1626 4 19.999C4 28.8364 11.1636 35.999 20 35.999ZM21.5 12.2995V18.5H27.7005C28.4182 18.5 29 19.14 29 19.9294V20.0706C29 20.86 28.4182 21.5 27.7005 21.5H21.5V27.7005C21.5 28.4182 20.86 29 20.0706 29H19.9294C19.14 29 18.5 28.4182 18.5 27.7005V21.5H12.2995C11.5818 21.5 11 20.86 11 20.0706V19.9294C11 19.14 11.5818 18.5 12.2995 18.5H18.5V12.2995C18.5 11.5818 19.14 11 19.9294 11H20.0706C20.86 11 21.5 11.5818 21.5 12.2995Z",
    fill: "#364356"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddGrey);
export default __webpack_public_path__ + "static/media/iconAddGrey.25a9955c.svg";
export { ForwardRef as ReactComponent };